import BaseEvaluator from './BaseEvaluator';

export default class NumericEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'numeric';
  }

  validate() {
    if (this.value === null || this.value === '' || this.value === undefined) {
      // Allow blank
      this.isValid = true;
    } else if (this.mutator[0] === null) {
      this.isValid = this.isInt() || this.isFloat();
    } else if (this.mutator[0] === 'int' || this.mutator[0] === 'integer') {
      this.isValid = this.isInt();
    } else if (this.mutator[0] === 'float' || this.mutator[0] === 'double') {
      this.isValid = this.isFloat();
    } else if (this.mutator[0] === 'currency') {
      this.isValid = this.isCurrency();
    }
    return this.isValid;
  }

  isInt() {
    return !Number.isNaN(this.value) && !Number.isNaN(parseInt(`${this.value}`, 10));
  }

  isFloat() {
    return !Number.isNaN(this.value) && !Number.isNaN(parseFloat(`${this.value}`));
  }

  isCurrency() {
    if (this.value !== undefined && this.value !== null) {
      return `${this.value}`.match(/(?=.)^\$?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+)?(\.[0-9]{1,})?$/) !== null;
    }
    return true;
  }
}
